// Environment variables
const isDevelopment = process.env.NODE_ENV === 'development';

// API Configuration
export const API_CONFIG = {
    // Base URL for API requests
    BASE_URL: 'https://api.lifevj.com',
    
    // API Endpoints
    ENDPOINTS: {
        AUTH: {
            LOGIN: '/auth/login',
            REGISTER: '/auth/signup',
            LOGOUT: '/auth/logout',
            GOOGLE: '/auth/google'
        },
        USER: {
            ME: '/users/me',
            UPDATE_PROFILE: '/users/me',
            UPDATE_PASSWORD: '/users/me/password'
        },
        NEWS: {
            LIST: '/news',
            DETAIL: (id) => `/news/${id}`,
            SOURCES: '/news-sources'
        },
        POSTS: {
            LIST: '/posts',
            DETAIL: (id) => `/posts/${id}`,
            CREATE: '/posts'
        },
        VIDEOS: {
            LIST: '/videos',
            DETAIL: (id) => `/videos/${id}`
        },
        CATEGORIES: '/categories'
    }
};

// OAuth Configuration
export const OAUTH_CONFIG = {
    GOOGLE: {
        CLIENT_ID: '870140613071-tk3ndnoahqau2s63ohhlgqh2rna3dns4.apps.googleusercontent.com'
    }
};

// Other Configuration
export const APP_CONFIG = {
    APP_NAME: 'LifeVJ',
    VERSION: '1.0.0',
    DEFAULT_LANGUAGE: 'en',
    SUPPORTED_LANGUAGES: ['en', 'vi']
}; 